export default __webpack_public_path__ + "static/media/default_carousel.84e31556.png";